module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Orange-4ada79bd8376db690ce2a1d9ff3816661f9afd168c4b28be4c53b88621442d6f.svg";